module.exports = __webpack_public_path__ + "img/weixin_code.769902c2.jpg";